<template>
  <div :class="!isMobileLayoutApplied ? 'lib__panel' : ''">
    <div :class="!isMobileLayoutApplied ? 'lib__panel__main' : ''" v-if="contactInfo.contactType === 'company'">
      <p :class="isMobileLayoutApplied ? ' lib__text-info' : ''">{{ $t("resume.societyInfo") }}</p>
      <ul v-if="!isMobileLayoutApplied" class="lib__list lib__list--icon">
        <li>
          <i class="fas fa-building"></i>
          {{ `${contactInfo.contactCompany.companyName} ${$t('contact.companyType.' +
            contactInfo.contactCompany.companyType)}` }}
        </li>
        <li>
          <i class="fas fa-map-marker-alt"></i>
          {{ `${contactInfo.contactCompany.address.street} ${contactInfo.contactCompany.address.streetNumber}
                    ${contactInfo.contactCompany.address.streetBox || ''}` }}
          <br>
          {{ `${contactInfo.contactCompany.address.zipCode} ${contactInfo.contactCompany.address.locality}` }}
          <br>
          {{ contactInfo.contactCompany.address.country }}
        </li>
      </ul>
      <div v-else>
        <p class="lib__text-weight-600 lib__no-margin">
          {{ `${contactInfo.contactCompany.companyName} ${$t('contact.companyType.' +
            contactInfo.contactCompany.companyType)}` }}
        </p>
        <p class="lib__text-weight-600 lib__no-margin">
          {{ `${contactInfo.contactCompany.address.street} ${contactInfo.contactCompany.address.streetNumber}
                    ${contactInfo.contactCompany.address.streetBox || ''}` }}
          <br>
          {{ `${contactInfo.contactCompany.address.zipCode} ${contactInfo.contactCompany.address.locality}` }}
          <br>
          {{ contactInfo.contactCompany.address.country }}
        </p>
      </div>
    </div>
    <div :class="!isMobileLayoutApplied ? 'lib__panel__main' : ''">
      <p :class="isMobileLayoutApplied ? ' lib__text-info' : ''">{{ contactInfo.contactType === 'company' ?
        $t("resume.representativeInfo") : $t("resume.applicantInfo") }}</p>
      <ul v-if="!isMobileLayoutApplied" class="lib__list lib__list--icon">
        <li>
          <i class="fas fa-user"></i>
          {{ contactName }}
        </li>
        <li v-if="contactInfo.contactType === 'freelance'">
          <i class="fas fa-building"></i>
          {{ `${$t('resume.societyNumber')} : ${contactInfo.contactFreelance && contactInfo.contactFreelance.vatNumber} ` }}
        </li>
        <li>
          <i class="fas fa-envelope"></i>
          {{ contactMail }}
        </li>
        <li :key="index" v-for="(contactPhone, index) in contactPhones">
          <i :class="contactPhone.mobile ? 'fa-mobile-alt' : 'fa-phone'" class="fas"></i>
          {{ contactPhone.nummer }}
        </li>
        <li v-if="contactInfo.contactType === 'individual' && contactInfo.contactIndividual && contactInfo.contactIndividual.bankAccountIban">
          <i class="fas fa-money-check-alt"></i>
          {{ contactInfo.contactIndividual && contactInfo.contactIndividual.bankAccountIban }} <span v-if="contactInfo.contactIndividual && contactInfo.contactIndividual.bankAccountBic"> -
          </span> {{ contactInfo.contactIndividual && contactInfo.contactIndividual.bankAccountBic }}
        </li>
        <li>
          <i class="fas fa-map-marker-alt"></i>
          {{ contactAddress }}
        </li>
      </ul>
      <div v-else>
        <p class="lib__text-weight-600 lib__no-margin">{{ contactName }}</p>
        <p v-if="contactInfo.contactType === 'freelance'" class="lib__text-weight-600 lib__no-margin">
          {{ `${$t('resume.societyNumber')} : ${contactInfo.contactFreelance && contactInfo.contactFreelance.vatNumber} ` }}
        </p>
        <p class="lib__text-weight-600 lib__no-margin">{{ contactMail }}</p>
        <p :key="index" v-for="(contactPhone, index) in contactPhones" class="lib__text-weight-600 lib__no-margin">
          {{ contactPhone.nummer }}
        </p>
        <p class="lib__text-weight-600 lib__no-margin">{{ contactAddress }}</p>
      </div>
    </div>

    <div :key="contact.lastname" :class="!isMobileLayoutApplied ? 'lib__panel__main' : ''"
      v-for="contact in contactInfo.otherContacts">
      <p :class="isMobileLayoutApplied ? ' lib__text-info' : ''">{{ $t("resume.otherContact") }}</p>
      <ul v-if="!isMobileLayoutApplied" class="lib__list lib__list--icon">
        <li>
          <i class="fas fa-user"></i>
          {{ `${otherContactName(contact)}` }}
        </li>
        <li>
          <i class="fas fa-briefcase"></i>
          {{ contact.job }}
        </li>
        <li>
          <i class="fas fa-envelope"></i>
          {{ contact.email }}
        </li>
        <li v-if="contact.phone">
          <i class="fas fa-mobile"></i>
          {{ contact.phone }}
        </li>
        <li v-if="contact.mobile">
          <i class="fas fa-phone"></i>
          {{ contact.mobile }}
        </li>
        <li>
          <i class="fas fa-map-marker-alt"></i>
          {{ `${contact.address.street} ${contact.address.streetNumber} ${contact.address.streetBox || ''}` }}
          <br>
          {{ `${contact.address.zipCode} ${contact.address.locality}` }}
          <br>
          {{ contact.address.country }}
        </li>
        <li v-if="contact.sendOfferCopy">
          {{ $t('contact.sendOfferCopy') }}
        </li>
      </ul>
      <div v-else>
        <p class="lib__text-weight-600 lib__no-margin">{{ `${contact.lastname} ${contact.firstname}` }}</p>
        <p class="lib__text-weight-600 lib__no-margin">{{ contact.job }}</p>
        <p class="lib__text-weight-600 lib__no-margin">{{ contact.email }}</p>
        <p v-if="contact.phone" class="lib__text-weight-600 lib__no-margin">{{ contact.phone }}</p>
        <p v-if="contact.mobile" class="lib__text-weight-600 lib__no-margin">{{ contact.mobile }}</p>
        <p class="lib__text-weight-600 lib__no-margin">
          {{ `${contact.address.street} ${contact.address.streetNumber} ${contact.address.streetBox || ''}` }}
          <br>
          {{ `${contact.address.zipCode} ${contact.address.locality}` }}
          <br>
          {{ contact.address.country }}
        </p>
        <p class="lib__text-weight-600 lib__no-margin" v-if="contact.sendOfferCopy">
          {{ $t('contact.sendOfferCopy') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ContactInfo, AddressPoint, ConsumptionAddress, ContactPerson } from '@/models'
import { contactService } from '@/services'

@Component
export default class ResumeContactInfo extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly contactInfo!: ContactInfo
  @Prop({ type: Object, required: true }) public readonly address!: AddressPoint | ConsumptionAddress
  @Prop({ type: Boolean, required: false, default: false }) public readonly isMobileLayoutApplied!: boolean
  //#endregion

  //#region [Method]
  //#endregion

  //#region [Computed]
  public get isConsumptionAddress(): boolean {
    return (this.address as ConsumptionAddress).cityName !== undefined
  }

  public get contactName(): string {
    switch (this.contactInfo.contactType) {
      case 'individual':
        if (this.contactInfo.contactIndividual) {
          let civility = null
          if (this.contactInfo.contactIndividual.civility === 1) {
            civility = this.$t('contact.civility.mr')
          } else if (this.contactInfo.contactIndividual.civility === 2) {
            civility = this.$t('contact.civility.mrs')
          }
          return `${civility} ${this.contactInfo.contactIndividual.firstname} ${this.contactInfo.contactIndividual.lastname}`
        }
        return ''
        break
      case 'freelance':
        if (this.contactInfo.contactFreelance) {
          let civility = null
          if (this.contactInfo.contactFreelance.civility === 1) {
            civility = this.$t('contact.civility.mr')
          } else if (this.contactInfo.contactFreelance.civility === 2) {
            civility = this.$t('contact.civility.mrs')
          }
          return `${civility} ${this.contactInfo.contactFreelance.firstname} ${this.contactInfo.contactFreelance.lastname}`
        }
        return ''
        break
      case 'company':
        if (this.contactInfo.contactCompany) {
          return `${this.contactInfo.contactCompany.firstname} ${this.contactInfo.contactCompany.lastname}`
        }
        return ''
        break
      default:
        return ''
        break
    }
  }

  public otherContactName(contactPerson: ContactPerson): string {
    if (contactPerson.civility) {
      let civility = null
      if (contactPerson.civility === 1) {
        civility = this.$t('contact.civility.mr')
      } else if (contactPerson.civility === 2) {
        civility = this.$t('contact.civility.mrs')
      }
      return `${civility} ${contactPerson.firstname} ${contactPerson.lastname}`
    }
    return ''
  }

  public get contactMail(): string {
    return contactService.getContactEmail(this.contactInfo)
  }

  public get contactPhones(): Array<{ mobile: boolean; nummer: string }> {
    switch (this.contactInfo.contactType) {
      case 'individual':
        if (this.contactInfo.contactIndividual) {
          return [
            {
              mobile: true,
              nummer: this.contactInfo.contactIndividual.mobile || ''
            },
            {
              mobile: false,
              nummer: this.contactInfo.contactIndividual.phone || ''
            }
          ].filter((n) => !!n.nummer)
        }
        break
      case 'freelance':
        if (this.contactInfo.contactFreelance) {
          return [
            {
              mobile: true,
              nummer: this.contactInfo.contactFreelance.mobile || ''
            },
            {
              mobile: false,
              nummer: this.contactInfo.contactFreelance.phone || ''
            }
          ].filter((n) => !!n.nummer)
        }
        break
      case 'company':
        if (this.contactInfo.contactCompany) {
          return [{ mobile: false, nummer: this.contactInfo.contactCompany.phone! }]
        }
        break
      default:
        return []
        break
    }
    return []
  }

  public get contactAddress(): string {
    if (this.contactInfo) {
      if (this.contactInfo.useWorksAddress) {
        if (this.contactInfo.contactType === 'company') {
          const address = this.contactInfo.contactCompany!.address
          return `${address.street} ${address.streetNumber} ${address.streetBox || ''} - ${address.zipCode} ${address.locality
            }`
        } else if (this.address) {
          if (!this.isConsumptionAddress) {
            const address = this.address as AddressPoint
            return address.isMapLocation
              ? `${address.mapLocation!.lat} ${address.mapLocation!.lng} ${address.subCity.zipCode} ${address.subCity.cityName
              }`
              : `${address.streetSubCity!.name} ${address.houseNumber} ${address.subCity.zipCode} ${address.subCity.cityName
              }`
          } else {
            const address = this.address as ConsumptionAddress
            return `${address.houseNumber} ${address.streetName} ${address.complement || ''} ${address.complementBox || ''
              } - ${address.zipCode} ${address.cityName}`
          }
        }
      } else if (this.contactInfo.otherAddress) {
        return `${this.contactInfo.otherAddress.street} ${this.contactInfo.otherAddress.streetNumber} ${this.contactInfo.otherAddress.streetBox || ''} - ${this.contactInfo.otherAddress.zipCode} ${this.contactInfo.otherAddress.locality} ${this.contactInfo.otherAddress.country}`
      }
    }
    return ''
  }
  //#endregion
}
</script>